module.exports = __webpack_public_path__ + "img/horizontal_7_2_6000.d686a398.png";